module.exports = __webpack_public_path__ + "img/logo.90dc98b5.png";